export default "__VITE_PUBLIC_ASSET__01a9e587__"